import {TableThingyView} from '../view/table_view';
import {connect} from "react-redux";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { requestDataFromAPI, deactivateUserFromAPI} from '../thunk/table_tunc';

interface OwnProps {
    id:string;
}

function mapStateToProps(state:RootState, ownProps:OwnProps){  
    const myprops=
    {
        data:state.tableUser.model,
    }
    return myprops;
}

function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
    return {
        onLoadRequested:()=>{ 
            dispatch(requestDataFromAPI() as any);
        },
        deactivateUser:(uuid:string)=>{ 
            dispatch(deactivateUserFromAPI(uuid) as any);
        },
        
    }
}


const UserTableContainer=connect(mapStateToProps, bindDispatchToActions)(TableThingyView);
export default UserTableContainer;